import { render, staticRenderFns } from "./RandomText.vue?vue&type=template&id=af66955a"
import script from "./RandomText.vue?vue&type=script&lang=js"
export * from "./RandomText.vue?vue&type=script&lang=js"
import style0 from "./RandomText.vue?vue&type=style&index=0&id=af66955a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports